import { useAuth } from "@/lib/auth";
import { useAppConfig } from "@/lib/appConfig";

// A workspace runs in one of two modes:
//   • "service" (default) — workflow: leads → cases → phases. No catalog tools.
//   • "product"           — catalog: inventory, labels, barcodes, media library.
// A starter pack sets the workspace mode to match its `kind`.
//
// `useCatalogMode()` is true when catalog/product features should show — either
// the single-business catalog BUILD, or a "product" workspace.
export function useCatalogMode() {
  const { orgs, activeOrgId } = useAuth();
  const { singleBusiness } = useAppConfig();
  const active = (orgs || []).find((o) => o.id === activeOrgId);
  return !!singleBusiness || active?.mode === "product";
}
